// E-ticaret / B2B: mağaza girişi, bayi koşulları, müşteri temsilcisi.
import React from 'react';
import { FormControlLabel, Grid, MenuItem, Switch, TextField, Typography, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { AccountCardForm } from '../useAccountCardForm';
import { L, SectionTitle } from './fields';

const B = 'current.modals.addAccount.b2b';

export const EcommerceSection: React.FC<{ f: AccountCardForm }> = ({ f }) => {
  const { t } = useTranslation('accounting');
  const d = f.accountData;
  const showErrors = !!f.error;
  return (
    <>
      <SectionTitle title={t(`${B}.sectionTitle`, { defaultValue: 'E-Ticaret / B2B' })} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<Switch checked={d.isEcommerceUser} onChange={(e) => f.handleChange('isEcommerceUser', e.target.checked)} />}
            label={t(`${L}.layout.storeLoginOn`, 'Mağaza girişi açık')}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<Switch checked={d.isB2BDealer} onChange={(e) => f.handleChange('isB2BDealer', e.target.checked)} />}
            label={t(`${B}.isB2BDealer`, { defaultValue: 'Bayi (B2B)' })}
          />
        </Grid>

        {d.isEcommerceUser && (
          <>
            <Grid item xs={12} sm={6}>
              <TextField
                id="account-card-ecom-user"
                fullWidth required size="small" autoComplete="off"
                label={t(`${B}.username`, { defaultValue: 'Kullanıcı Adı' })}
                error={showErrors && !d.ecomUsername.trim()}
                value={d.ecomUsername} onChange={(e) => f.handleChange('ecomUsername', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth size="small" type="password" autoComplete="new-password"
                required={!f.linkedMember}
                error={showErrors && !f.linkedMember && !d.ecomPassword}
                label={f.linkedMember
                  ? t(`${B}.passwordNew`, { defaultValue: 'Yeni Şifre (boşsa değişmez)' })
                  : t(`${B}.password`, { defaultValue: 'Şifre' })}
                value={d.ecomPassword} onChange={(e) => f.handleChange('ecomPassword', e.target.value)}
              />
            </Grid>
          </>
        )}

        {d.isB2BDealer && (
          <>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth size="small" type="number"
                label={t(`${B}.discountPercent`, { defaultValue: 'E-Ticaret İskontosu (%)' })}
                value={d.ecommerceDiscountPercent} onChange={(e) => f.handleChange('ecommerceDiscountPercent', e.target.value)}
                inputProps={{ min: 0, max: 100, step: 0.01 }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                select fullWidth size="small"
                label={t(`${B}.priceBasis`, { defaultValue: 'İskonto Baz Fiyatı' })}
                value={d.ecommercePriceBasis} onChange={(e) => f.handleChange('ecommercePriceBasis', e.target.value)}
              >
                <MenuItem value="SalePrice">{t(`${B}.priceBasisSale`, { defaultValue: 'Satış Fiyatı' })}</MenuItem>
                <MenuItem value="ListPrice">{t(`${B}.priceBasisList`, { defaultValue: 'Liste Fiyatı' })}</MenuItem>
              </TextField>
            </Grid>
          </>
        )}
        <Grid item xs={12} sm={d.isB2BDealer ? 4 : 6}>
          <TextField
            fullWidth size="small"
            label={t('current.modals.addAccount.fields.customerRepresentative', { defaultValue: 'Müşteri Temsilcisi' })}
            value={d.customerRepresentative} onChange={(e) => f.handleChange('customerRepresentative', e.target.value)}
            inputProps={{ maxLength: 100 }}
          />
        </Grid>
        {d.isB2BDealer && (
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={d.blockOrdersWhenOverdue}
                  onChange={(e) => f.handleChange('blockOrdersWhenOverdue', e.target.checked)}
                />
              }
              label={t(`${B}.blockOrdersWhenOverdue`, { defaultValue: 'Vadesi geçmiş borç varken vadeli sipariş verilemesin' })}
            />
          </Grid>
        )}
      </Grid>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        {f.linkedMember
          ? t(`${B}.linkedHint`, {
              defaultValue: 'Bu cariye bağlı bir e-ticaret üyesi var ({{email}}). Kullanıcı adı/şifre değişiklikleri bu üyeye uygulanır.',
              email: f.linkedMember.email,
            })
          : t(`${L}.layout.ecomHint`, 'Mağaza girişi için e-posta zorunlu; eksikse İletişim bölümüne götürür. Müşteri temsilcisi B2B vitrininde üyeye gösterilir.')}
      </Typography>
    </>
  );
};
